let Api = window.location.host
export const API =  Api ===  "agent.paddycover.com" ?  'https://api.paddycover.com/v1' : 'https://stage.paddycover.com/v1' 

// 'https://api.paddycover.com/v1'


// https://stage.paddycover.com/v1